module.exports = __webpack_public_path__ + "static/media/kts.369d28b2.webp";